<template>
  <div class="date-editor">
    <Datepicker
      ref="datepicker"
      :value="selectedDate"
      @selected="setDate"
      calendar-class="datepicker-calendar"
      :style="{ border: 0 }"
      :inline="true"
      :monday-first="true"
    />
    <div v-if="showTimePicker" class="date-editor__time-picker">
      <FormFieldInput
        type="time"
        :value="selectedTime"
        variant="vertical"
        :placeholder="$t('hh:mm')"
        :label="$t('Startzeit')"
        @update="setTime"
      />
    </div>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';

import FormFieldInput from '@/shared/components/form/FormFieldInput.vue';

const TIME_REGEX = /^([01]\d|2[0-3]):([0-5]\d)$/;

export default {
  name: 'DateEditor',
  data() {
    return {
      selectedDate: null,
      selectedTime: '',
      showTimePicker: false,
    };
  },
  components: { Datepicker, FormFieldInput },
  methods: {
    setDateTime(date, showTimePicker = false) {
      this.showTimePicker = showTimePicker;

      if (date == null && !showTimePicker) {
        this.selectedDate = null;
        this.selectedTime = '';
        return;
      }

      const selectedDate = date == null ? new Date() : new Date(date);
      this.selectedDate = selectedDate;
      this.selectedTime = this.formatTime24h(selectedDate);
    },
    setDate(date) {
      if (date == null) return;
      this.selectedDate = this.showTimePicker ? this.withSelectedTime(date) : date;
      this.$emit('input', this.selectedDate);
    },
    setTime(valueOrEvent) {
      const time = typeof valueOrEvent === 'string' ? valueOrEvent : valueOrEvent?.target?.value;
      const parsedTime = this.parseTime(time);
      if (!parsedTime) return;

      this.selectedTime = time;
      const date = this.selectedDate == null ? new Date() : this.selectedDate;
      this.selectedDate = this.withSelectedTime(date);
      this.$emit('input', this.selectedDate);
    },
    withSelectedTime(date) {
      const parsedTime = this.parseTime(this.selectedTime);
      if (!parsedTime) return new Date(date);

      const selectedDate = new Date(date);
      selectedDate.setHours(parsedTime.hours, parsedTime.minutes, 0, 0);
      return selectedDate;
    },
    parseTime(time) {
      if (typeof time !== 'string' || !TIME_REGEX.test(time)) {
        return null;
      }
      const [hours, minutes] = time.split(':').map((part) => Number(part));
      return { hours, minutes };
    },
    formatTime24h(date) {
      const hours = `${date.getHours()}`.padStart(2, '0');
      const minutes = `${date.getMinutes()}`.padStart(2, '0');
      return `${hours}:${minutes}`;
    },
  },
};
</script>

<style>
.date-editor {
  display: flex;
  background: var(--white);
  border-radius: 2px;
  box-shadow: 0 25px 50px rgba(0, 0, 50, 0.1), 0 8px 20px rgba(0, 0, 50, 0.15), 0 5px 7px rgba(0, 0, 0, 0.05);
}

.date-editor__time-picker {
  padding: 0px 12px;
}

.form-field-input__input.form-control {
  height: auto;
}

.datepicker-calendar {
  border: none !important;
  padding-right: 16px !important;
  box-shadow: none !important;
  border-radius: 0 !important;
}

.datepicker-calendar .day {
  border-radius: 6px !important;
}

.datepicker-calendar .day:hover {
  background: var(--primary) !important;
}

.datepicker-calendar .day.selected:hover {
  background: var(--primary) !important;
}

.datepicker-calendar .day.selected {
  background: var(--primary_light) !important;
}
</style>
